import { useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'

import useTimer from '@shared/hooks/useTimer'
import { getCookie, pollExpirationMessage, setCookie } from '@shared/utils'
// import { graphqlClient } from '@shared/components/queryGraphql'
import { ADD_POLL_ANSWER } from '@graphql/poll/poll.mutation'

function usePoll({ poll }) {
  const [pollData, setPollData] = useState(poll)
  const [selectedOption, setSelectedOption] = useState(isAlreadyAnswered(poll?._id))

  const date = new Date()
  date.setDate(date.getDate() + 1) // Add 1 days to the current date

  const { timer } = useTimer(pollData?.dEndDate || date, 60000)
  const { message, isExpired } = pollExpirationMessage(timer)

  const [answerPoll] = useMutation(ADD_POLL_ANSWER)

  async function handleAnswer(iOptionId) {
    if (!isAlreadyAnswered(pollData?._id) && !isExpired) {
      const sFingerPrint = localStorage.getItem('UPId')
      // const { data } = await graphqlClient.mutate({
      //   mutation: ADD_POLL_ANSWER,
      //   variables: {
      //     input: {
      //       iSlideId: pollData?._id,
      //       iPollId: pollData?.parentId,
      //       iOptionId,
      //       sFingerPrint
      //     }
      //   }
      // })
      const { data } = await answerPoll({
        variables: { input: { iSlideId: pollData?._id, iPollId: pollData?.parentId, iOptionId, sFingerPrint } }
      })
      if (data?.updatePollCount?.sMessage) {
        setSelectedOption(iOptionId)
        handleAnswerRes(iOptionId)
        handleChangePoll(iOptionId)
      }
    }
  }

  function isAlreadyAnswered(id) {
    if (typeof window === 'undefined') return
    const pollAnswered = getCookie(id)
    return pollAnswered || undefined
  }

  function handleAnswerRes(iOptionId) {
    setCookie({
      cName: pollData?._id,
      cValue: iOptionId,
      exDays: timer?.days || 1
    })
    const p = { ...pollData }
    p.nTotalVote = p?.nTotalVote + 1
    p.aField = p.aField.map((field) => (field._id === iOptionId ? { ...field, nVote: field.nVote + 1 } : field))
    setPollData(p)
  }

  const isActive = (id) => (id && selectedOption === id ? 'active' : '')

  function getPercentage(nVote) {
    return Math.trunc(pollData?.nTotalVote >= nVote ? (nVote * 100) / pollData?.nTotalVote : 0) || 0
    // return pollData?.nTotalVote >= nVote ? (nVote * 100) / pollData?.nTotalVote : 0
  }

  function handleChangePoll(iOptionId) {
    if (poll?.parentId) {
      const event = new CustomEvent(poll?.parentId, {
        bubbles: true,
        detail: { iOptionId }
      })
      document.dispatchEvent(event)
    }
  }

  useEffect(() => {
    setPollData(poll)
    poll?._id && setSelectedOption(isAlreadyAnswered(poll?._id))
  }, [poll])

  return {
    pollData,
    selectedOption,
    message,
    isExpired,
    handleAnswer,
    isActive,
    getPercentage
  }
}
export default usePoll
